import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Formik } from 'formik';
import IconLock from 'components/icons/iconLock2';
import Checkbox from 'components/consumer/Checkbox';
import CtaButton from 'components/essentials/Cta/CtaButton';
import SmartyStreetsFloatingField from 'components/essentials/SmartyStreetsFloatingField';
import ZipField from 'components/consumer/checkout/desktop/components/Shipping/components/ZipField';
import CityField from 'components/consumer/checkout/desktop/components/Shipping/components/CityField';
import StateField from 'components/consumer/checkout/desktop/components/Shipping/components/StateField';
import EmailField from 'components/consumer/checkout/desktop/components/EmailForm/components/EmailField';
import LastNameField from 'components/consumer/checkout/desktop/components/Shipping/components/LastNameField';
import ApartmentField from 'components/consumer/checkout/desktop/components/Shipping/components/ApartmentField';
import FirstNameField from 'components/consumer/checkout/desktop/components/Shipping/components/FirstNameField';
import PhoneNumberField from 'components/consumer/checkout/desktop/components/Shipping/components/PhoneNumberField';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import TwoColumnFormFields from 'components/consumer/TwoColumnFormFields';
import { INVALID_NAME_CHARACTERS_REGEX, EMAIL_REGEX, PHONE_REGEX, ZIP_CODE_REGEX } from 'commons/constants';
import ValidationError from 'components/consumer/ValidationError';
const INITIAL_VALUES = {
  email_address: '',
  first_name: '',
  last_name: '',
  address: '',
  city: '',
  apartment: '',
  company: '',
  state: '',
  zipcode: '',
  phone_number: '',
  request_type: '',
  isAccess: false,
  isDeletion: false,
  isAgreed: false
};
const formSchema = Yup.object().shape({
  email_address: Yup.string().required('Email address is required').matches(EMAIL_REGEX, 'Invalid email'),
  first_name: Yup.string().required('Required').test('test-fname', 'No invalid characters allowed', value => !INVALID_NAME_CHARACTERS_REGEX.test(value)),
  last_name: Yup.string().required('Required').test('test-lname', 'No invalid characters allowed', value => !INVALID_NAME_CHARACTERS_REGEX.test(value)),
  address: Yup.string().required('Street address is required').min(6, 'Street Address must contain minimum six characters'),
  city: Yup.string().required('City is required'),
  apartment: Yup.string(),
  state: Yup.string().required('State is required'),
  zipcode: Yup.string().required('Zip code is required').matches(ZIP_CODE_REGEX, 'Invalid zip code'),
  phone_number: Yup.string().required('Please enter a valid phone number').matches(PHONE_REGEX, 'Invalid phone number'),
  request_type: Yup.string().required('Request type is required'),
  isAgreed: Yup.boolean().oneOf([true], 'Please agree to the terms')
});
const DSRForm = t0 => {
  const $ = _c(6);
  const {
    state,
    actions
  } = t0;
  const addressRef = useRef();
  let t1;
  if ($[0] !== state.errMsg || $[1] !== state.isLoading) {
    t1 = t2 => {
      const {
        values,
        errors,
        touched,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
        setFieldTouched
      } = t2;
      return <form data-xc="dsr-form" className="dsr-form" onSubmit={handleSubmit}><EmailField isLoggedIn={false} handleBlur={handleBlur} handleChange={handleChange} value={values.email_address} error={errors.email_address} isTouched={touched.email_address} /><TwoColumnFormFields><FirstNameField handleBlur={handleBlur} error={errors.first_name} value={values.first_name} handleChange={handleChange} isTouched={touched.first_name} /><LastNameField handleBlur={handleBlur} error={errors.last_name} value={values.last_name} handleChange={handleChange} isTouched={touched.last_name} /></TwoColumnFormFields><PhoneNumberField placeholder="Phone" handleBlur={handleBlur} handleChange={handleChange} error={errors.phone_number} value={values.phone_number} isTouched={touched.phone_number} /><SmartyStreetsFloatingField showError={true} refField={addressRef} error={errors.address} value={values.address} handleBlur={handleBlur} handleChange={handleChange} isTouched={touched.address} setFieldValue={setFieldValue} /><TwoColumnFormFields><ApartmentField showError={true} value={values.apartment} error={errors.apartment} handleBlur={handleBlur} handleChange={handleChange} isTouched={touched.apartment} placeholder="Apartment / Suite #" /><CityField value={values.city} error={errors.city} isTouched={touched.city} handleBlur={handleBlur} handleChange={handleChange} /></TwoColumnFormFields><TwoColumnFormFields><StateField value={values.state} error={errors.state} handleBlur={handleBlur} isTouched={touched.state} setFieldValue={setFieldValue} setFieldTouched={setFieldTouched} /><ZipField value={values.zipcode} error={errors.zipcode} handleBlur={handleBlur} isTouched={touched.zipcode} handleChange={handleChange} /></TwoColumnFormFields><br /><div className={cx("flex p-4 mt-6 rounded border border-solid", {
          "border-brand": values.request_type === "Access",
          "border-gray-light7": values.request_type !== "Access"
        })}><Checkbox size="sm" checked={values.request_type === "Access"} onChange={() => {
            setFieldValue("request_type", values.request_type !== "Access" ? "Access" : "");
          }}><div className="CheckboxButtonPanel__label-content"><div className="text-base font-bold mb-2">Request Personal Information Summary</div><div className="text-sm">I'd like to request access to all of my personal information in Joybird's possession</div></div></Checkbox></div><div className={cx("flex p-4 mt-6 rounded border border-solid", {
          "border-brand": values.request_type === "Deletion",
          "border-gray-light7": values.request_type !== "Deletion"
        })}><Checkbox size="sm" checked={values.request_type === "Deletion"} onChange={() => {
            setFieldValue("request_type", values.request_type !== "Deletion" ? "Deletion" : "");
          }}><div className="CheckboxButtonPanel__label-content"><div className="text-base font-bold mb-2">Request Deletion of All Personal Information</div><div className="text-sm">I'd like to request the deletion of all my personal information in Joybird's possession. This excludes any information that would help us service orders/warranty claims.</div></div></Checkbox></div>{(touched.isDeletion || touched.isAccess) && errors.request_type && <ValidationError data-xc="dsr-request-validation">{errors.request_type}</ValidationError>}<LabeledTextInput id="additionalInformation" type="text" name="additional_information" label="Additional Information or Requests" onChange={handleChange} onBlur={handleBlur} value={values.additional_information} data-xc="additional-information-field" /><div className="flex p-4 mt-6 rounded border border-solid border-gray-light7"><Checkbox color="default" name="isAgreed" checked={values.isAgreed} onChange={() => {
            setFieldValue("isAgreed", !values.isAgreed);
          }}><div className="CheckboxButtonPanel__label-content"><div className="text-base font-bold mb-2">I agree to the following terms:</div><div className="text-sm">By checking this box you agree and attest as follows: (i) the information you are submitting is true and accurate under penalty of law, (ii) you have the legal right to submit the information herein, (iii) the information is being submitted by a legitimate purpose under the California Privacy Act, and (iv) you understand that the information you have provided will be used to review and process your request</div></div></Checkbox></div>{touched.isAgreed && errors.isAgreed && <ValidationError data-xc="dsr-agree-validation">{errors.isAgreed}</ValidationError>}<CtaButton type="submit" color="black" noLinkPadding={true} hasArrow={false} styling="solid-button" data-xc="dsr-submit-btn" disabled={state.isLoading} loading={state.isLoading} className="w-full mt-8"><IconLock /> Send My Request</CtaButton>{!!state.errMsg && <ValidationError data-xc="dsr-form-validation">{state.errMsg}</ValidationError>}</form>;
    };
    $[0] = state.errMsg;
    $[1] = state.isLoading;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== actions.createDSRRequest || $[4] !== t1) {
    t2 = <Formik name="dsrForm" initialValues={INITIAL_VALUES} validationSchema={formSchema} onSubmit={actions.createDSRRequest} render={t1} />;
    $[3] = actions.createDSRRequest;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
DSRForm.propTypes = {
  state: PropTypes.shape({
    isLoading: PropTypes.bool,
    errMsg: PropTypes.string
  }),
  actions: PropTypes.shape({
    createDSRRequest: PropTypes.func
  })
};
export default DSRForm;